import React from 'react';
import styled from 'styled-components';
import {
  FlightSkeletonSticks,
  FlightSkeletonLine,
} from '@lt/components/icons-react/userflow/flights/skeleton';

type Props = {
  loadingFlightsText: string;
};

const LoadingFlightSticks = ({ loadingFlightsText }: Props) => (
  <StyledWrapper>
    <SticksContainer>
      <StyledTopPart>
        <StyledSticks>
          <StyledFlightSkeletonLine width="120" />
          <StyledFlightSkeletonSticks width="101" />
        </StyledSticks>
        <StyledSticks>
          <StyledFlightSkeletonLine width="120" />
          <StyledFlightSkeletonLine width="189" />
        </StyledSticks>
      </StyledTopPart>
      <StyledBottomPart>
        <StyledBottomText>{loadingFlightsText}</StyledBottomText>
      </StyledBottomPart>
    </SticksContainer>
  </StyledWrapper>
);
const StyledWrapper = styled.div`
  display: flex;
  padding: 8px;
  align-items: flex-end;
  gap: 4px;
  align-self: stretch;
  background: #fff;
`;

const SticksContainer = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 4px;
  width: 100%;
  align-self: flex-end;
  background: #f3f2e8;
`;

const StyledTopPart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

const StyledSticks = styled.div`
  display: flex;
  width: 224px;
  flex-direction: column;
  align-items: flex-start;
`;

const StyledFlightSkeletonLine = styled(FlightSkeletonLine)`
  padding: 8px 0px;
`;

const StyledFlightSkeletonSticks = styled(FlightSkeletonSticks)`
  padding: 5px 0px;
`;

const StyledBottomPart = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #d6d5c9;
`;
const StyledBottomText = styled.span`
  color: #d6d5c9;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 114.286% */
`;
export default LoadingFlightSticks;
